import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { useIntl } from 'react-intl';
import Link from '@nubank/nuds-web/components/Link/Link';

import TabNavigation from 'components/tab/TabNavigation/TabNavigation';
import { maybeFormatMessage } from 'utils/i18nUtils';

const TabLink = props => (
  <Link
    {...props}
    typographyProps={{
      variant: 'subtitle',
    }}
    noStyle
  />
);

function TabNavLinks({ links, router }) {
  const intl = useIntl();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    setSelectedTabIndex(links.findIndex(({ href }) => href === router.pathname));
  }, []);

  const renderTabLabel = ({ linkText }) => maybeFormatMessage(intl, linkText);

  return (
    <TabNavigation
      labelsArray={links.map(renderTabLabel)}
      selectedTabIndex={selectedTabIndex}
      TabButtonComponent={TabLink}
      tabButtonComponentData={links.map(({ href }) => ({
        color: 'inherit',
        href,
        locale: intl.locale,
      }))}
    />
  );
}

TabNavLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    }),
  ).isRequired,
  router: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default withRouter(TabNavLinks);
